import { NavLink } from "react-router-dom";
import { Target } from "lucide-react";
import { useT } from "../../../../i18n/I18nProvider";
import { Card, CardHead, fmtMoney, fmtNum } from "../../../ui";
import type { DashFunnelStage } from "../../../../lib/dashboard";

/**
 * The pipeline as bars, widest at the top.
 *
 * The width is the stage's share of the FIRST stage, not of the total: a funnel
 * is about how much survives each step, and normalising to the sum would make a
 * healthy pipeline and a stalled one look identical.
 */
export function FunnelCard({ funnel }: { funnel: DashFunnelStage[] }) {
  const t = useT();
  const top = Math.max(1, funnel[0]?.count ?? 0);
  const totalValue = funnel.reduce((s, f) => s + f.valueCents, 0);
  const totalCount = funnel.reduce((s, f) => s + f.count, 0);

  return (
    <Card>
      <CardHead title={t("dash.funnel.title")} sub={t("dash.funnel.sub")} />
      <div className="crm-funnel">
        {funnel.map((stage) => (
          <NavLink key={stage.status} className="crm-fstage" to={`/leads?status=${stage.status}`}>
            <span className="crm-ftop">
              <b>{t(`leads.status.${stage.status}`)}</b>
              <span className="crm-tnum">{fmtNum(stage.count)}</span>
              <span className="crm-fv">{fmtMoney(stage.valueCents)}</span>
            </span>
            <span className="crm-fbar">
              <i style={{ width: `${Math.round((stage.count / top) * 100)}%` }} />
            </span>
          </NavLink>
        ))}
        <div className="crm-fnote">
          <Target className="size-3" />
          {t("dash.funnel.total")} <b>{fmtMoney(totalValue)}</b> &middot; {t("dash.funnel.avg")}{" "}
          <b>{fmtMoney(totalCount ? Math.round(totalValue / totalCount) : 0)}</b>
        </div>
      </div>
    </Card>
  );
}
